//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tidalIcon from '@tidal/styles-icons';
import { generalArrowDown, generalArrowUp } from '@tidal/styles-icons';
import { tidalTransitionExpand } from '@tidal/styles-animation';

export default {
    components: {
        tidalIcon,
        tidalTransitionExpand,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
        /** @type {import('vue').PropOptions<Array<Record<string, any>>>} */
        options: {
            type: Array,
            required: true,
        },
        preselectedOption: {
            type: Object,
            default: () => null,
        },
        unselectedText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showOptions: false,
            isCollapsed: true,
            selectedOptionText: '',
            generalArrowDown,
            generalArrowUp,
            value: null,
        };
    },
    computed: {
        /** @returns {string|null} */
        preselectedOptionText() {
            if (this.preselectedOption && this.preselectedOption.value) {
                return this.preselectedOption.text;
            }
            return null;
        },
    },
    methods: {
        /** @param {Record<string, any>} option */
        selectOption(option) {
            this.showOptions = false;
            this.selectedOptionText = option.text;
            this.value = option.value;
            this.$emit('select', option);
        },
        toggleShowOptions() {
            this.showOptions = !this.showOptions;
        },
        expandLeave() {
            this.isCollapsed = true;
        },
        expandEnter() {
            this.isCollapsed = false;
        },
    },
};
